// Duplicated from ab-common
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { addingNotes, addingPrivateNotes, newNoteSelector } from '@applyboard/ab-common';

// used to get "addingNote" from the state

var addingNoteProps = createStructuredSelector({
  addingNote: addingNotes,
  addingPrivateNote: addingPrivateNotes,
  newNote: newNoteSelector
});
var addingNoteEnhancer = connect(addingNoteProps);
export default addingNoteEnhancer;